/**
 * Footer aur category page ke "Related categories" strip ke liye top 8 category.
 *
 * Slug wahi hai jo backend sitemap banata hai (lhw sitemap.service.ts ka slugify)
 * aur wahi /c/:slug route match karta hai — category ka naam DB me badle to slug
 * yahan bhi badalna, warna link /categories par redirect ho jaayega.
 */
export interface TopCategory {
  slug: string;
  label: string;
}

export const TOP_CATEGORIES: TopCategory[] = [
  { slug: "tmt-bar", label: "TMT Bar" },
  { slug: "cement", label: "Cement" },
  { slug: "gc-sheet", label: "GC Sheet" },
  { slug: "gp-sheet", label: "GP Sheet" },
  { slug: "square-pipe", label: "Square Pipe" },
  { slug: "round-pipe", label: "Round Pipe" },
  { slug: "angle", label: "Angle" },
  { slug: "channel", label: "Channel" },
];
